// Reactive
import {Observable, of, throwError} from 'rxjs';
import {first, map, mergeMap, skipWhile, takeUntil} from 'rxjs/operators';
// App store
import {Store} from '@ngrx/store';
import {ADD_APP_ID, ADD_APPLICATION_ID, AppState, UPDATE_AGENT, UPDATE_CONTENT, UPDATE_PERSONA} from '../app-reducer';
// Popup
import { MatDialog } from '@angular/material/dialog';
import { NewRelicService } from '../../../../../../angular-app/projects/brokerage-eapp/src/app/services/newrelic.service';
import { ModalComponent } from '../../../../../src/app/components/modal.component';
import { PendingBlocksAlertComponent } from './pending-blocks-alert.component';
// Services
import { ProcessorService } from '../services/processor.service';
import { NavigationService } from '../services/navigation.service';
import { ApiService } from 'src/app/services/api.service';
import { QuestionService } from '../services/question.service';
import { ComposableService } from '../services/composable.service';
// Utilities
import {ChangeDetectorRef, Component, OnInit, AfterViewChecked, AfterViewInit, Input} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {cloneDeep, find, get, isEmpty} from 'lodash';
import { animate, transition, style, trigger} from '@angular/animations';
import { ControlContainer, FormGroup, Validators, FormControl } from '@angular/forms';
import { QuestionBase } from 'src/app/models/question-base';
import { Subject } from 'rxjs';
import { AppConstants } from '../app.constants';
import { CommonService } from '../services/common.service';
import {Buffer} from 'buffer';

@Component({
  selector: 'mini-portal',
  templateUrl: './producer-mini-portal.component.html',
  styles: [],
  animations: [
    trigger(
      'enterAnimation', [
        transition(':enter', [
          style({transform: 'translateX(100%)', opacity: 0}),
          animate('500ms', style({transform: 'translateX(0)', opacity: 1}))
        ]),
        transition(':leave', [
          style({transform: 'translateX(0)', opacity: 1}),
          animate('500ms', style({transform: 'translateX(100%)', opacity: 0}))
        ])
      ]
    )
  ],
})

export class MiniPortalComponent implements OnInit, AfterViewChecked {
  constructor(
    private newRelicService: NewRelicService,
    private apiService: ApiService,
    private changeDetection: ChangeDetectorRef,
    private composableService: ComposableService,
    private disclosure: MatDialog,
    private navigationService: NavigationService,
    private processorService: ProcessorService,
    private route: ActivatedRoute,
    public router: Router,
    public service: QuestionService,
    private store: Store<AppState>,
    private appConstants: AppConstants,
    private commonService: CommonService
  ) {
    this.appState$ = store.select('sections');
    this.payload = window['jhConfig'].payload;
  }

  // ----------------------------- Start Component Properties ------------------------------- //

  //start illustration

  blockIndex: number = 1;

  uploadResponse: string;
  illustrationFiles = [];
  public oopsMsg: any = false;
  public tooManyFiles: string = 'This question only accepts one illustration file.';
  public badResponse: string = 'Something has gone wrong.  Please try again.';
  public onlyPDFs: string = 'This question only accepts PDF files.';
  public filePickerFormGroup: FormGroup;
  formGroupParent: any;
  preFillContent: any = null;
  defaultValues: any = null;
  isOptional = false;
  throwOverlay = false;

  fileToUpload: File = null;
  // Agent Info
  agentName: string;
  AgentId: string;
  AgentFirstName: string;
  AgentLastName: string;
  AgentEmailAddress: string;

  // General
  appState$: Observable<any>;
  date = new Date();
  private _onDestroy = new Subject();
  payload: any;

  // Application Group & Applications
  isDemo = false;
  loadingAgentApplications = true;
  startNewApp = false;
  processing = false;
  selectedTable = 0;
  showOpenedApps = true;
  showSubmittedApps = false;
  submittedAgentApplications;
  lastTableIndex = 0;
  lastIndexBeforeElipses = 6;
  lastIndexAfterElipses;
  openedAgentApplications;
  tableIndex = 0;
  tableIndeces = [];
  inProgressApplications;
  submittedApplications;
  getAgentAppsCallFinished = false;
  applicationIdPath = 'data.ApplicationId';
  appAuthIdPath = 'data.AppAuthId';
  AgentPhoneNumber= '555-55-5555';
  appId: any;

  // Email
  lastEmailSent: any;

  // Config Links
  JH_ILLUSTRATION_URL: string;
  JH_NEW_BUSINESS_CASE_URL: string;

  // ----------------------------- End Component Properties ------------------------------- //

  // On init
  ngOnInit() {    
    this.newRelicService.addPageAction('MiniPortal ngOnInit Start', { status: 'started' });
    // Reset app state
    this.composableService.resetApplication();
    this.appState$.pipe(first()).subscribe((state: any) => {
      this.appId = state.appId;
      state.isDemo = false;
      this.commonService.logAppState(state);
    });

    // Get producer credentials from ISAM headers or use hard-coded values for local and dev
    this.AgentId = (window['jhConfig'].ivuser !== '') ? window['jhConfig'].ivuser : 'DreamFinFit';
    this.AgentFirstName = (window['jhConfig'].firstname !== '') ? unescape(window['jhConfig'].firstname) : 'Dream';
    this.AgentLastName = (window['jhConfig'].lastname !== '') ? unescape(window['jhConfig'].lastname) : 'FinFit';
    this.agentName = (this.AgentFirstName && this.AgentLastName) ? this.AgentFirstName + ' ' + this.AgentLastName : 'Kim Possible';
    this.AgentEmailAddress = (window['jhConfig'].email !== '') ? window['jhConfig'].email : 'test@test.com';

    // Other config values
    this.JH_ILLUSTRATION_URL = window['jhConfig'].JH_ILLUSTRATION_URL;
    this.JH_NEW_BUSINESS_CASE_URL = window['jhConfig'].JH_NEW_BUSINESS_CASE_URL;

    this.route.queryParams
      .subscribe(params => {
        if (params) {
          this.AgentId = params.AgentId ? params.AgentId : this.AgentId;
          this.AgentEmailAddress = params.AgentEmailAddress ? params.AgentEmailAddress : this.AgentEmailAddress;
          this.AgentFirstName = params.AgentFirstName ? decodeURIComponent(params.AgentFirstName) : this.AgentFirstName;
          this.AgentLastName = params.AgentLastName ? decodeURIComponent(params.AgentLastName) : this.AgentLastName;
          this.agentName = this.AgentFirstName + ' ' + this.AgentLastName;
        }
      });

    // Retrieve producer applications
    this.getAgentApplications();
    //this.getAgentApplicationsV2();
    this.changeDetection.detectChanges();

    // Handle app state when an application is selected
    this.appState$.pipe(
      skipWhile((state: any) => {
        return (state.formData === null) || (state.questions === null)
      }),
      first()
    ).subscribe((state) => {
      if (state.questions) {
        const routes = this.router.config;
        const newRoutes = routes.map(item => {
        const { data } = item;
        if (data && data.blockHeading && data.blockName && data.blockName !== 'intake' && data.hasOwnProperty('isProgressRoute')) {
          const questionBlocks = find(state.questions, { Name: data.blockName });
          item.data.blockCategory = questionBlocks.BlockCategory || null;
          item.data.blockHeading = questionBlocks.DisplayName || null;
        }
        return item;
        });
        this.navigationService.buildNavStore(newRoutes);
      };
    });
  }

  // After view init for change detection
  ngAfterViewInit() {
    if( this.inProgressApplications && this.inProgressApplications.length >= 0 && this.submittedApplications && this.submittedApplications.length >= 0 ) {
      this.lastIndexAfterElipses = this.inProgressApplications.length;
      this.loadingAgentApplications = false;
      this.processing = false;
      this.changeDetection.detectChanges();
    }
    this.showApplications(this.tableIndex);
    this.changeDetection.detectChanges();
  }

  // After view checked for change detection
  ngAfterViewChecked() {
    if( this.inProgressApplications && this.inProgressApplications.length >= 0 && this.submittedApplications && this.submittedApplications.length >= 0 ) {
      this.lastIndexAfterElipses = this.inProgressApplications.length;
      this.loadingAgentApplications = false;
      this.processing = false;
      this.changeDetection.detectChanges();
    }
    this.changeDetection.detectChanges();
  }

  // On Destroy for change detection
  // Cancellation
  ngOnDestroy() {
    this._onDestroy.next();
  }

  // Track Applications for ngFor
  trackByApplicationId(obj) {
    return obj.appId;
  }

    // Retrieve applications for an agent
  // Servive: JHADE
  // getAgentApplicationsV2() {
  //   console.log('Retrieving agent applications');
  //   this.apiService.getAgentApplicationsV2(this.AgentId).pipe(takeUntil(this._onDestroy)).subscribe(response => {
  //     if (response.code === 200 && response.data) {
  //       const completeApps = [];
  //       const incompleteApps = [];

  //       response.data.Applications.forEach(app => {
  //         let customerEmails;
  //         let appId = get(app, 'Id');
  //         const req = {
  //           'appId': appId
  //         };

  //         // Handle cases where proposed insured was already sent an email to continue their application
  //         if (app.EmailLogs) {
  //           customerEmails = of(app.EmailLogs).pipe(map(items => items.filter(item => item.email_type == 'CustomerContinueApplicationEmailLink' && item.email_status == 2)));
  //           customerEmails.subscribe((e: any) => { app.CustomerEmailSent = e.length > 0; });
  //         }
  //         // Separate the applications by in-progress and submitted (incomplete and complete respectively)
  //         if (app.DecisionClassName !== null) {
  //           completeApps.push(app);
  //         } else {
  //           incompleteApps.push(app);
  //         }
  //       });

  //       // Split in progress applications into groups of n
  //       // n = 5
  //       this.inProgressApplications = incompleteApps;
  //       this.inProgressApplications = this.splitApplicationGroupIntoGroupsOfN(this.inProgressApplications, 5);

  //       // Get default table indecies
  //       this.getSelectedTableIndecies();
  //       // Default last index for default table (in-progress is the default table)
  //       this.lastIndexAfterElipses = (Math.ceil(incompleteApps.length/5) - 1);
  //       // Show default table
  //       this.showApplications(this.tableIndex);

  //       // Split submitted applications into groups of n
  //       // n = 5
  //       this.submittedApplications = completeApps;
  //       this.submittedApplications = this.splitApplicationGroupIntoGroupsOfN(this.submittedApplications, 5);

  //       this.processing = false;
  //       this.loadingAgentApplications = false;
  //       this.getAgentAppsCallFinished = true;
  //       this.changeDetection.detectChanges();
  //     } else {
  //       console.log('Failed to get applications');
  //       // Error pop up and handling
  //       this.timeoutPopup();
  //       this.loadingAgentApplications = false;
  //       this.processing = false;
  //       this.getAgentAppsCallFinished = true;
  //       this.changeDetection.detectChanges();
  //     }
  //   }, (error) => {
  //     console.log('ERROR');
  //     console.log(error);
  //     this.timeoutPopup();
  //     this.loadingAgentApplications = false;
  //     this.processing = false;
  //     this.getAgentAppsCallFinished = true;
  //     this.changeDetection.detectChanges();
  //   });
  // }


  // Retrieve applications for an agent
  // Servive: JHADE
  getAgentApplications() {
    console.log('Retrieving agent applications');
    this.apiService.getAgentApplications(this.AgentId).pipe(takeUntil(this._onDestroy)).subscribe(response => {
      if (response.code === 200 && response.data) {
        const completeApps = [];
        const incompleteApps = [];

        response.data.Applications.forEach(app => {
          let customerEmails;
          const appId = get(app, 'Id');
          app.totalSignators = 1; //proposed insured
          app.signedSignators = 0; //no complete signatures
          const req = {
            'appId': appId
          };
          if (app.CustomerSigned === 1) {
            app.signedSignators += 1;
          }
          if (app.OwnershipSignatories) {
            if (app.OwnershipSignatories.length == 1 && app.OwnershipSignatories[0].Role == 'InsuredOwner'){
              app.insuredSoleOwner=true;
            }else{
              app.insuredSoleOwner=false;
              app.totalSignators += app.OwnershipSignatories.length;
              app.signedSignators += app.OwnershipSignatories.filter(x => x.Signed == true).length;
              }
            }
            app.allOwnersSigned = app.totalSignators == app.signedSignators ? true: false;

          // Handle cases where proposed insured was already sent an email to continue their application
          if (app.EmailLogs) {
            customerEmails = of(app.EmailLogs).pipe(map(items => items.filter(item => item.email_type == 'CustomerContinueApplicationEmailLink' && item.email_status == 2)));
            customerEmails.subscribe((e: any) => { app.CustomerEmailSent = e.length > 0; });
            app.insuredEmails = app.EmailLogs.filter(item => item.email_type == 'CustomerContinueApplicationEmailLink' && item.email_status == 2);

            app.ownerEmails = app.EmailLogs.filter(item => item.email_type == 'ThirdPartyOwnerReadyToSign' && item.email_status == 2);
            //add a subscription here...
          }
          // Separate the applications by in-progress and submitted (incomplete and complete respectively)
          if (app.DecisionClassName !== null) {
            completeApps.push(app);
          } else {
            incompleteApps.push(app);
          }
        });

        // Split in progress applications into groups of n
        // n = 5
        this.inProgressApplications = incompleteApps;
        this.inProgressApplications = this.splitApplicationGroupIntoGroupsOfN(this.inProgressApplications, 5);

        // Get default table indecies
        this.getSelectedTableIndecies();
        // Default last index for default table (in-progress is the default table)
        this.lastIndexAfterElipses = (Math.ceil(incompleteApps.length/5) - 1);
        // Show default table
        this.showApplications(this.tableIndex);

        // Split submitted applications into groups of n
        // n = 5
        this.submittedApplications = completeApps;
        this.submittedApplications = this.splitApplicationGroupIntoGroupsOfN(this.submittedApplications, 5);

        this.processing = false;
        this.loadingAgentApplications = false;
        this.getAgentAppsCallFinished = true;
        this.changeDetection.detectChanges();
      
      } else {
        console.log('Failed to get applications');
        // Error pop up and handling
        this.timeoutPopup();
        this.loadingAgentApplications = false;
        this.processing = false;
        this.getAgentAppsCallFinished = true;
        this.changeDetection.detectChanges();
        this.navigationService.nextSectionRelative('error');
       
      }
    }, (error) => {
      console.log('ERROR');
      console.log(error);
      this.newRelicService.noticeError(error, { appId: this.appId });
      this.timeoutPopup();
      this.loadingAgentApplications = false;
      this.processing = false;
      this.getAgentAppsCallFinished = true;
      this.changeDetection.detectChanges();
      this.navigationService.nextSectionRelative('error');
    });
  }

  // start new application
  startNewApplication(illustrationFlag:boolean = false) {
    this.appState$.pipe(first()).subscribe((state: any) => {
      state.isDemo = false;
     this.commonService.logAppState(state);;
    });
    this.processing = true;
    if (illustrationFlag) {
      this.startNewApp = true;
    }
    this.changeDetection.detectChanges();

    // start eApp
    const data = {};

    // subscribe to application changes
    this.apiService.startApplication(data).pipe(
      mergeMap((response: any) => {
        // error handling
        if (get(response, 'code') !== 200 || !get(response, this.applicationIdPath)) {
          this.navigationService.nextSectionRelative('error');
          return;
      }
      else{
        
        // update store
        this.store.dispatch({
          type: ADD_APP_ID,
          payload: get(response, this.appAuthIdPath)
        });

        // update store
        this.store.dispatch({
          type: ADD_APPLICATION_ID,
          payload: get(response, this.applicationIdPath)
        });

        // update store
        this.store.dispatch({
          type: UPDATE_AGENT,
          payload: {
            agentFirstname: this.AgentFirstName,
            agentLastname: this.AgentLastName,
            agentEmail: this.AgentEmailAddress,
            agentPhoneNumber: this.AgentPhoneNumber,
          }
        });

        if (!illustrationFlag) {
          this.goToEapp(illustrationFlag);
        }
      }
        return this.appState$;
      }),
      first(),
      mergeMap((response: any) => {
        // Navigate to eApp
        if (illustrationFlag) {
          this.goToEapp(illustrationFlag);
          this.startNewApp = false;
          this.changeDetection.detectChanges();
        }

        const requestPayload = {
          appAuthId: response.appAuthId,
          AgentId: this.AgentId,
          payload: {
            agentPhoneNumber: '555-55-5555',
            agentInfo: get(response, 'payload.agentInfo') || null
          },
          agentFirstname: this.AgentFirstName,
          agentLastname: this.AgentLastName,
          agentEmail: this.AgentEmailAddress

        };

        const processAppPayload = {
          AppAuthId: response.appAuthId,
          AppId: response.appId,
          AgentId: this.AgentId,
          AgentFirstName: this.AgentFirstName,
          AgentLastName: this.AgentLastName,
          AgentEmail: this.AgentEmailAddress
        };

        this.apiService.processApplication(processAppPayload).subscribe(res => {
          console.log(res);
        }, (error) => {
          console.log('ERROR');
          console.log(error);
          this.newRelicService.noticeError(error, { appId: this.appId });
          this.startNewApp = false;
          this.processing = false;
          });

        return this.apiService.saveInfo(requestPayload);
      }),
    ).subscribe((response) => {

			// trigger observable holding block submissions until application pre-processing is done
			this.navigationService.readyToSubmit(true);

      this.appState$.pipe(first()).subscribe((state: any) => {
        if (illustrationFlag) {
          state.prefillVals = true;
        }
      });


    }, (errorResponse) => {
      this.navigationService.nextSectionRelative('error');
      });
    

  }

  // Start new application
  startDemoApplication() {
    this.appState$.pipe(first()).subscribe((state: any) => {
      state.isDemo = true;
     this.commonService.logAppState(state);
    });
    this.processing = true;

    // Initialize application data
    const data = {};

    // Subscribe to application changes
    this.apiService.startDemoApplication(data).pipe(
      mergeMap((response: any) => {
        // Error handling
        if (get(response, 'code') !== 200 || !get(response, this.applicationIdPath)) {
          return throwError(response);
        }

        // Update store
        this.store.dispatch({
          type: ADD_APP_ID,
          payload: get(response, this.appAuthIdPath)
        });

        // Update store
        this.store.dispatch({
          type: ADD_APPLICATION_ID,
          payload: get(response, this.applicationIdPath)
        });

        // Update store
        this.store.dispatch({
          type: UPDATE_AGENT,
          payload: {
            agentFirstname: this.AgentFirstName,
            agentLastname: this.AgentLastName,
            agentEmail: this.AgentEmailAddress,
            agentPhoneNumber: this.AgentPhoneNumber,
          }
        });

        return this.appState$;
      }),
      first(),
      mergeMap((response: any) => {
        const requestPayload = {
          appAuthId: response.appAuthId,
          AgentId: this.AgentId,
          estimateDetails: get(response, 'estimateDetails'),
          salesSource: get(response, 'salesSource '),
          payload: {
            agentPhoneNumber: this.AgentPhoneNumber,
            agentInfo: get(response, 'payload.agentInfo') || null
          },
          agentFirstname: this.AgentFirstName,
          agentLastname: this.AgentLastName,
          agentEmail: this.AgentEmailAddress

        };

        const processAppPayload = {
          AppAuthId: response.appAuthId,
          AppId: response.appId,
          AgentId: this.AgentId,
          AgentFirstName: this.AgentFirstName,
          AgentLastName: this.AgentLastName,
          AgentEmail: this.AgentEmailAddress
        };

        this.apiService.processApplication(processAppPayload).subscribe(res => {
          console.log(res);
        }, (error) => {
            console.log('ERROR');
            console.log(error);
            this.newRelicService.noticeError(error, { appId: this.appId });
            this.loadingAgentApplications = false;
            this.processing = false;
        });

        return this.apiService.saveInfo(requestPayload);
      }),
    ).subscribe((response) => {

			// trigger observable holding block submissions until application pre-processing is done
			this.navigationService.readyToSubmit(true);

    }, (errorResponse) => {
      this.navigationService.nextSectionRelative('error');
      this.newRelicService.noticeError(errorResponse, { appId: this.appId });
      });
    // enter eApp
    this.goToEapp();

  }

  resumeApplication(element: any = {}) {

    // update store
    this.store.dispatch({
      type: UPDATE_PERSONA,
      payload: { customerSigned: element.CustomerSigned }
    });

    this.store.dispatch({
      type: UPDATE_CONTENT,
      payload: { signators: element.OwnershipSignatories }
    });

    // Processing flag
    this.processing = true;

    // Resume request payload
    const resumePayload = {
      'AppAuthId': element.AuthId,
      'AppId': element.Id
    };

    this.apiService.dbResumeApplication(resumePayload).subscribe(response => {
      if (response.code === 200 && response.data) {
        let resumeAppObj = {
          ...response.data
        };

        // If there are any pending jobs/blocks in the queue wait until it finishes
        if (response.data.PendingJobs) {
            const modalRef = this.disclosure.open(PendingBlocksAlertComponent, {
                disableClose: true,
                hasBackdrop: true,
                data: {
                    resumePayload,
                    PendingJobs: response.data.PendingJobs
                }
            });
            this.processing = false;
            this.changeDetection.detectChanges();

            modalRef.afterClosed().subscribe(checkResult => {
                resumeAppObj = {...checkResult.data};
                this.continueWithTheApplication(checkResult, resumeAppObj, false, element.CustomerSigned && element.allOwnersSigned);
            });
            return false;
        }

        this.continueWithTheApplication(response, resumeAppObj, false, element.CustomerSigned && element.allOwnersSigned);

      } else {
        console.log('Failure to resume application');
        this.processing = false;
        this.changeDetection.detectChanges();
      }
    }, (error) => {
      console.log('ERROR');
      console.log(error);
      this.newRelicService.noticeError(error, { appId: this.appId });
      this.loadingAgentApplications = false;
      this.processing = false;
      this.changeDetection.detectChanges();
    });

  }

  continueWithTheApplication(response: any, resumeAppObj: any, unLockApp: boolean = false, readyForAgentFinalPass: boolean = false, goToEapp: boolean = true) {
    // Raw payload
    console.log('unLockApp: ', unLockApp);
    const rawPayload = resumeAppObj.EAppRawPayload;
    const payload = rawPayload ? window['JSON'].parse((Buffer.from(rawPayload,'base64')).toString()) : {};

    const resumeBlock = readyForAgentFinalPass ? 'agent-report' : this.appConstants.proposedInsuredPath;
    console.log('payload: ', payload);
    const appAuthId = get(response, this.appAuthIdPath);
    console.log('payload.DeclarationsInsured ', payload.DeclarationsInsured);
    let overWritePayload;
      if (unLockApp && payload.DeclarationsInsured) {

        // Creates empty DeclarationsInsured payload to send to JHADE
        overWritePayload = cloneDeep(payload.DeclarationsInsured);
        overWritePayload = Object.keys(overWritePayload).reduce(
          (accumulator, current) => {
            accumulator[current] = null;
            return accumulator;
          }, {});
        delete overWritePayload['SignatureBase'];
        delete overWritePayload['SignatureInsuredLocation'];
        delete overWritePayload['customerIpAddress'];
        delete overWritePayload['DateX'];
        overWritePayload['InsuredLoadTime'] = 2;

        // Removes DeclarationsInsured block from eAppRawPayload and current session
        delete payload.DeclarationsInsured;
      }

      const ownerDeclarations = ['DeclarationsOwnerA', 'DeclarationsOwnerB', 'DeclarationsOwnerC', 'DeclarationsOwnerD', 'DeclarationsOwnerE', 'DeclarationsOwnerF', 'DeclarationsOwnerG', 'DeclarationsOwnerH', 'DeclarationsOwnerI', 'DeclarationsOwnerJ'];

      if (unLockApp && ownerDeclarations.some(x => x in payload)) {

        // Erases DeclarationsOwnerX from appStore
        ownerDeclarations.forEach((ownerBlock, i) => {
          if (ownerBlock in payload) {
            delete payload[ownerBlock];
          }
        });
      }

      // maps PrimaryResidence.State to StateOfIssue when the latter is absent to avoid breaking in-flight cases when StateOfIssue is added
      if (payload.SECTIONAProposedInsured && payload.SECTIONAProposedInsured.PrimaryResidence.State && !payload.SECTIONAProposedInsured.StateOfIssue) {
        payload.SECTIONAProposedInsured.StateOfIssue = payload.SECTIONAProposedInsured.PrimaryResidence.State;
      }

      // Update store
      this.store.dispatch({
          type: ADD_APP_ID,
          payload: appAuthId
      });

    // update store
    this.store.dispatch({
      type: ADD_APPLICATION_ID,
      payload: get(response, this.applicationIdPath)
    });

    // Update agent info
    this.store.dispatch({
      type: UPDATE_AGENT,
      payload: {
        agentFirstname: this.AgentFirstName,
        agentLastname: this.AgentLastName,
        agentEmail: this.AgentEmailAddress,
        agentPhoneNumber: this.AgentPhoneNumber,
      }
    });

    //  Update store
    this.store.dispatch({
        type: UPDATE_CONTENT,
        payload: payload
    });


    // Clear DeclarationsInsured
    if (unLockApp && goToEapp) {

      // Mark disclosures and declarations as unvisited in menuData
      this.appState$.pipe(first()).subscribe((state: any) => {
        // Console.log('app state content in unlock: ', state);
        state.content.menuData.find(x=>x.name === 'Disclosures').valid = null;
        state.content.menuData.find(x=>x.name === 'DeclarationsInsured').valid = null;
        state.content.menuData.find(x=>x.name === 'DeclarationsInsured').visible = false;
        state.content.menuData.find(x=>x.name === 'DeclarationsInsured').questions = [];
        ownerDeclarations.forEach(ownerBlock => {
          state.content.menuData.find(x => x.name === ownerBlock).valid = null;
          state.content.menuData.find(x => x.name === ownerBlock).visible = null;
          state.content.menuData.find(x => x.name === ownerBlock).questions = [];
        });
      });

      console.log('overWritePayload: ', overWritePayload);

      if (overWritePayload){
        this.processorService.submitSection({ appAuthId, section: 'DeclarationsInsured', payload: overWritePayload });
      }
      this.appState$.pipe(first()).subscribe((state: any) => {
        state.unlocked = true;
      });
      this.goToEapp(false, this.appConstants.proposedInsuredPath);
    }
    else if(!unLockApp && goToEapp){

      // enter eApp
      this.goToEapp(false, resumeBlock);
    } else {
      const payloadFromIllustration = rawPayload ? window['JSON'].parse((Buffer.from(rawPayload,'base64')).toString()) : this.service.generateRawPayload(resumeAppObj.QuestionBlocks,resumeAppObj.QuestionBlockResponses);
      this.store.dispatch({
        type: UPDATE_CONTENT,
        payload: payloadFromIllustration
      });

      this.goToEapp();
    }
  }

  startWithIllustrationModal() {
    const modalRef = this.disclosure.open(ModalComponent, {
      disableClose: true,
      closeOnNavigation: true,
      data: {
        size: '',
        // Array of screens
        screens: [
          {
            show: true,
            exit_btn: true,
            content: [
              {
                type: 'title',
                content: 'Do you want to start with illustration?',
                class: this.appConstants.modalTitleBold
              },
              {
                type: 'button_group',
                buttons: [
                  {
                    type: 'button',
                    label: 'No',
                    clickFunction: 'startWithoutIllustration',
                    class: this.appConstants.buttonSecondary
                  },
                  {
                    type: 'button',
                    label: 'Yes',
                    clickFunction: 'startWithIllustration',
                    class: this.appConstants.buttonPrimary
                  }
                ]
              }
            ]
          }
        ]
      }
    });

    modalRef.afterClosed().pipe(first()).subscribe(result => {
    if (result.event == "startWithIllustration") {

      this.startNewApplication(true);

     } else if (result.event == "startWithoutIllustration") {
       this.startNewApplication(false);
     }
    })
  }

  unlockThisApplication(element: any = {}) {
    // Update store
    this.store.dispatch({
      type: UPDATE_PERSONA,
      payload: { customerSigned: 0 } // This app is editable now!
    });

    // Processing flag
    this.processing = true;

    // Resume request payload
    const resumePayload = {
      'AppAuthId': element.AuthId,
      'AppId': element.Id
    };

    this.apiService.dbResumeApplication(resumePayload).pipe(takeUntil(this._onDestroy)).subscribe(response => {
      if (response.code === 200 && response.data) {
        let  resumeAppObj = {
          ...response.data
        };

        // If there are any pending jobs/blocks in the queue wait until it finishes
        if (response.data.PendingJobs > 0) {
            const modalRef = this.disclosure.open(PendingBlocksAlertComponent, {
                disableClose: true,
                hasBackdrop: true,
                data: {
                    resumePayload,
                    PendingJobs: response.data.PendingJobs
                }
            });
            this.processing = false;
            this.changeDetection.detectChanges();

            modalRef.afterClosed().subscribe(checkResult => {
                resumeAppObj = {...checkResult.data};
                this.continueWithTheApplication(checkResult, resumeAppObj);
            });
            return false;
        }

        this.continueWithTheApplication(response, resumeAppObj, true);

      } else {
        console.log('Failure to resume application');
        this.processing = false;
        this.changeDetection.detectChanges();
      }
    }, (error) => {
        console.log('ERROR');
        console.log(error);
        this.newRelicService.noticeError(error, { appId: this.appId });
        this.loadingAgentApplications = false;
        this.processing = false;
        this.changeDetection.detectChanges();
    });

  }

  // Shows on: Portal time out and or issues loading agent applications
  timeoutPopup() {
    const modalRef = this.disclosure.open(ModalComponent, {
      disableClose: true,
      closeOnNavigation: true,
      data: {
        size: '',
        // Array of screens
        screens: [
          {
            show: true,
            exit_btn: true,
            content: [
              {
                type: 'title',
                content: 'Having trouble loading? Try refreshing the browser.',
                class: this.appConstants.modalTitleBold
              },
              {
                type: 'button_group',
                buttons: [
                  {
                    type: 'Refresh',
                    label: 'Try Again',
                    clickFunction: 'goToAgentPortal',
                    class: this.appConstants.buttonPrimary
                  }
                ]
              }
            ]
          }
        ]
      }
    });
  }

  // Send a email to proposed insured associated with the desired application
  // Email type: ContinueApplication
  sendThisApplication($event, appId, email, firstName, lastName) {
    $event.preventDefault();

    // Send relevant info to popup
    const AppId = appId;
    const AgentId = this.AgentId;
    const ProposedInsuredEmailAddress = email;
    const ProposedInsuredName = firstName + ' ' + lastName;

    const modalRef = this.disclosure.open(ModalComponent, {
      disableClose: true,
      closeOnNavigation: true,
      data: {
        AppId: AppId,
        AgentId: AgentId,
        ProposedInsuredEmailAddress: email,
        ProposedInsuredName: firstName + ' ' + lastName,
        size: '',
        // Array of screens
        emailInitError: (!(this && ProposedInsuredName && ProposedInsuredEmailAddress)),
        screens: [
          {
            show: true,
            exit_btn: true,
            content: [
              {
                type: 'title',
                content: 'Send application',
                class: this.appConstants.modalTitleBold
              },
              {
                type: 'text',
                content: 'To share this application with ' + ProposedInsuredName + ', click "Send" below.',
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'text',
                content: 'The email will be sent to ' + ProposedInsuredEmailAddress + '.',
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'text',
                content: 'Once ' + ProposedInsuredName + ' accesses the e-application, they will be able to:',
                class: this.appConstants.modalLiDefault
              },
              {
                type: 'unordered_list',
                unordered_list: [
                  {
                    type: 'unordered_list_item',
                    content: 'Review completed sections',
                    class: this.appConstants.modalLiDefault
                  },
                  {
                    type: 'unordered_list_item',
                    content: 'Complete any outstanding medical and/or lifestyle questions, and',
                    class: this.appConstants.modalLiDefault
                  },
                  {
                    type: 'unordered_list_item',
                    content: 'Electronically sign the e-application',
                    class: this.appConstants.modalLiDefault
                  },
                ]
              },
              {
                type: 'button_group',
                buttons: [
                  {
                    type: 'button',
                    label: 'Cancel',
                    clickFunction: 'close',
                    class: this.appConstants.buttonSecondary
                  },
                  {
                    type: 'button',
                    label: 'Send',
                    clickFunction: 'sendEmail',
                    class: this.appConstants.buttonPrimary
                  }
                ]
              },
            ]
          },
          // Success Screen
          {
            show: false,
            exit_btn: false,
            content: [
              {
                type: 'title',
                content: 'Success!',
                class: this.appConstants.modalTitleBold
              },
              {
                type: 'text',
                content: 'We have sent the application to ' + ProposedInsuredName + ' at ' + ProposedInsuredEmailAddress + '.',
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'text',
                content: 'Once ' + ProposedInsuredName + '  has signed the application, you will receive an email notification with next steps.',
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'text',
                content: 'You can also track the status of the ' + ProposedInsuredName + ' signature in the JH eApp portal.',
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'button',
                label: this.appConstants.eAppPortalLabel,
                clickFunction: 'goToAgentPortal',
                class: this.appConstants.buttonPrimary
              }
            ]
          },
          // Failure Screen
          {
            show: false,
            exit_btn: false,
            content: [
              {
                type: 'title',
                content: this.appConstants.somethingWentWrong,
                class: this.appConstants.modalTitleBold
              },
              {
                type: 'text',
                content: this.appConstants.technicalError,
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'button_group',
                buttons: [
                  {
                    type: 'button',
                    label: 'Try Again',
                    clickFunction: 'sendEmail',
                    class: this.appConstants.buttonSecondary
                  }
                ]
              }
            ]
          },
          // Fail on retry screen
          {
            show: false,
            exit_btn: false,
            content: [
              {
                type: 'title',
                content: this.appConstants.technicalIssueTitle,
                class: this.appConstants.modalTitleBold
              },
              {
                type: 'text',
                content: this.appConstants.technicalFailureMessage,
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'text',
                content: this.appConstants.inconvenienceMessage,
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'button_group',
                buttons: [
                  {
                    type: 'button',
                    label: this.appConstants.eAppPortalLabel,
                    clickFunction: 'goToAgentPortal',
                    class: this.appConstants.buttonPrimary
                  }
                ]
              }
            ]
          },
          {
            show: false,
            exit_btn: false,
            content: [
              {
                type: 'title',
                content: "Thank you for completing your portion of the application.",
                class: this.appConstants.modalTitleBold
              },
              {
                type: 'text',
                content: 'In the next 2-3 minutes, ' + ProposedInsuredName + ' should receive an email at ' + ProposedInsuredEmailAddress + ' that includes a link to their sections of the application.',
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'text',
                content: 'Once ' + ProposedInsuredName + ' has electronically signed the application, you will receive an email notification with next steps.',
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'text',
                content: 'You can also track the status of the ' + ProposedInsuredName + "'s signature in the JH eApp portal.",
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'button_group',
                buttons: [
                  {
                    type: 'button',
                    label: this.appConstants.eAppPortalLabel,
                    clickFunction: 'goToAgentPortal',
                    class: this.appConstants.buttonPrimary
                  }
                ]
              }
            ]
          }
        ]
      }
    });

    modalRef.componentInstance.emailSentForAppId.subscribe(result => {
      console.log('emailSentForAppId', result);
      if (result == appId) {
        this.loadingAgentApplications = true;
        this.getAgentApplications();
        //this.getAgentApplicationsV2();
      }
    });
  }

  // Unlocks an application after the proposed insured has signed
  // and needs to make changes (inputs in certain sections become locked when...
  // ...the proposed insured signs )
  unlockApplication($event, element: any = {}) {
    $event.preventDefault();

    const modalRef = this.disclosure.open(ModalComponent, {
      disableClose: true,
      closeOnNavigation: true,
      data: {
        size: '',
        // Array of screens
        screens: [
          {
            show: true,
            exit_btn: true,
            content: [
              {
                type: 'title',
                content: 'Important note about unlocking',
                class: this.appConstants.modalTitleBold
              },
              {
                type: 'text',
                content: 'Please note that this application has been signed by the proposed insured and/or policy owner(s) (if applicable). If you unlock the application, those parties will need to repeat the signature process, even if no changes are made to the application. If you would still like to proceed, click "unlock" below.',
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'button_group',
                buttons: [
                  {
                    type: 'button',
                    label: 'Cancel',
                    clickFunction: 'close',
                    class: this.appConstants.buttonSecondary
                  },
                  {
                    type: 'button',
                    label: 'Unlock',
                    clickFunction: 'unlock',
                    class: this.appConstants.buttonPrimary
                  }
                ]
              }
            ]
          }
        ]
      }
    });

    modalRef.componentInstance.unlockedForAppId.subscribe(result => {
      console.log('unlock', result);
      if (result == true) {
        this.loadingAgentApplications = true;
        this.changeDetection.detectChanges();
        modalRef.componentInstance.close();
        this.unlockThisApplication(element);
      }
    });

  }

  // Navigate to eApp
  // Destination varies app to app
  goToEapp(illustrationFlag:boolean = false, dest?: string): void {

    // go to next section
    this.appState$.pipe(
      // tslint:disable-next-line:indent
      skipWhile((state: any) => {
        return (state.formData === null) || (state.questions === null);
      }),
      first()
    ).subscribe((state) => {
			if (state.questions) {
			  const routes = this.router.config;
			  const newRoutes = routes.map(item => {
          const { data } = item;
          if (data && data.blockHeading && data.blockName && data.blockName !== 'intake' && data.hasOwnProperty('isProgressRoute')) {
            const questionBlocks = find(state.questions, { Name: data.blockName });
            item.data.blockCategory = questionBlocks.BlockCategory || null;
            item.data.blockHeading = questionBlocks.DisplayName || null;
          }
          return item;
			  });
        this.navigationService.buildNavStore(newRoutes);
			};

      if (dest) {
        this.navigationService.nextSectionRelative(dest);
      } else {
        if (illustrationFlag) {
          this.navigationService.nextSectionRelative('illustration-start');
        } else {
          this.navigationService.nextSectionRelative(this.appConstants.proposedInsuredPath);
        }
      }
      // Don't remove -- trigger observable holding block submissions until application pre-processing is done
      this.navigationService.readyToSubmit(true);
    });
  }

  // Get table indecies of the selected table
  getSelectedTableIndecies(){
    if(this.selectedTable === 0 && this.inProgressApplications) {
      this.lastIndexAfterElipses === this.inProgressApplications.length - 1;
      if(this.inProgressApplications.length > 6) {
        // arranged in [index display value, index actual value] format
        this.tableIndeces = [
          [1, 0],
          [2, 1],
          [3, 2],
          [4, 3],
          [5, 4],
          [this.lastIndexBeforeElipses, this.lastIndexBeforeElipses - 1],
          ['...', null],
          [this.lastIndexAfterElipses, this.lastIndexAfterElipses - 1]
        ];
      }else {
        this.tableIndeces = [];
        for(let i = 0; i < this.inProgressApplications.length; i++){
          // arranged in [index display value, index actual value] format
          this.tableIndeces.push([i + 1, i]);
        }
      }
    } else if(this.selectedTable === 1 && this.submittedApplications) {
      this.lastIndexAfterElipses = this.submittedApplications.length - 1;
      if(this.submittedApplications.length > 6) {
        this.tableIndeces = [
          [1, 0],
          [2, 1],
          [3, 2],
          [4, 3],
          [5, 4],
          [this.lastIndexBeforeElipses, this.lastIndexBeforeElipses - 1],
          ['...', null],
          [this.lastIndexAfterElipses, this.lastIndexAfterElipses - 1]
        ];
      } else {
        this.tableIndeces = [];
        for(let i = 0; i < this.submittedApplications.length; i++){
          this.tableIndeces.push([i+1, i]);
        }
      }
    }
    return this.tableIndeces;
  }

  // Show which group of applications you want to view
  showApplications(tableIndex) {
    switch (tableIndex) {
      case 0:
        this.showSubmittedApps = false;
        this.showOpenedApps = true;
        this.selectedTable = 0;
        this.tableIndex = 0;
        if( this.inProgressApplications && this.inProgressApplications.length >= 0) {
          this.lastIndexAfterElipses = this.inProgressApplications.length;
          this.loadingAgentApplications = false;
          this.processing = false;
        }
        this.getSelectedTableIndecies();
        this.changeDetection.detectChanges();
        break;

      case 1:
        this.showOpenedApps = false;
        this.showSubmittedApps = true;
        this.selectedTable = 1;
        this.tableIndex = 0;
        if( this.submittedApplications && this.submittedApplications.length >= 0) {
          this.lastIndexAfterElipses = this.submittedApplications.length;
          this.loadingAgentApplications = false;
          this.processing = false;
        }
        this.getSelectedTableIndecies();
        this.changeDetection.detectChanges();
        break;

      default:
        break;
    }
  }

  // Splits applications into groups of n
  // Each set of n will be located in their respective
  // index tab group
  splitApplicationGroupIntoGroupsOfN(array, n) {
    const [...arr]  = array;
    const res = [];
    while (arr.length) {
      res.push(arr.splice(0, n));
    }
    return res;
  }

  // Function to change pages/tabs when
  // the navigation buttons are interacted with
  transitionWithNavButtons(direction) {
    if (this.selectedTable === 0) {
      if (direction !== 'forward') {
        if (this.tableIndex !== 0) {
          if(this.tableIndex === this.lastIndexBeforeElipses && this.lastIndexBeforeElipses >= 6) {
            this.lastIndexBeforeElipses = this.tableIndex;
            this.getSelectedTableIndecies();
          } else if(this.lastIndexBeforeElipses > 6) {
            this.lastIndexBeforeElipses -= 1;
            this.getSelectedTableIndecies();
          }
          this.tableIndex -= 1;
          this.changeDetection.detectChanges();
        }
      } else {
        if (this.tableIndex !== (this.lastIndexAfterElipses - 1)) {
          this.tableIndex += 1;
          if(this.tableIndex === this.lastIndexBeforeElipses) {

            if(this.lastIndexBeforeElipses + 1 !== this.lastIndexAfterElipses) {
              this.lastIndexBeforeElipses += 1;
            }

            this.getSelectedTableIndecies();
          }
          this.changeDetection.detectChanges();
          this.lastTableIndex = this.tableIndex;
        }
      }
    } else {
        if (direction !== 'forward') {
          if (this.tableIndex !== 0) {
            if(this.tableIndex === this.lastIndexBeforeElipses && this.tableIndex >= 6) {
              this.lastIndexBeforeElipses = this.tableIndex;
              this.getSelectedTableIndecies();
            } else if(this.lastIndexBeforeElipses > 6) {
              this.lastIndexBeforeElipses -= 1;
              this.getSelectedTableIndecies();
            }
            this.tableIndex -= 1;
            this.changeDetection.detectChanges();
          }
        } else {
          if (this.tableIndex !== (this.lastIndexAfterElipses - 1)) {
            this.tableIndex += 1;
            if(this.tableIndex === this.lastIndexBeforeElipses) {
              if(this.lastIndexBeforeElipses + 1 !== this.lastIndexAfterElipses) {
                  this.lastIndexBeforeElipses += 1;
              }
              this.getSelectedTableIndecies();
            }
            this.changeDetection.detectChanges();
          }
        }
      }
  }

  goToPaginationIndex(index) {
    console.log('index ', index);
    this.tableIndex = index;
    this.lastIndexBeforeElipses = index <= 5 ? 6 : (index);
    this.getSelectedTableIndecies();
    this.changeDetection.detectChanges();
  }

  // Navigate to demo welcome page
  goToDemoWelcome():void {
    this.appState$.pipe(first()).subscribe((state: any) => {
      state.isDemo = true;
      this.commonService.logAppState(state);
    });
     //console.log('Going to Demo app!');
     this.navigationService.nextSectionRelativeNewWindow('demo-welcome');
  }

  // Opens illustration button link in new window
  openIllustrationLink() {
    window.open(this.JH_ILLUSTRATION_URL, '_blank');
  }

  // Checks if an application is also a demo application
  isDemoApp(app: any) {
    const appId = get(app, 'Id');
    let isDemo;
    const req = {
      'appId': appId
    };
    this.apiService.isDemoApplication(req).subscribe((res) => {
      isDemo = res;
      console.log(res);
    });
    return isDemo;
  }

  openSignatorsModal($event, element: any = {}) {
    //console.log('element ', element);
    element.OwnershipSignatories.forEach(owner => {
      owner.OwnerEmails = [];
      if (element.ownerEmails){
        element.ownerEmails.forEach(email => {
          if (owner.SignerEmail == JSON.parse(email.payload).To[0].email){
            // console.log("pushing", JSON.parse(email.payload).To[0].email);
            owner.OwnerEmails.push(email);
          }
        })
      }
    }
    )

    //var allOwnersSigned = element.totalSignators == element.signedSignators ? true: false;
    console.log(cloneDeep(element.OwnershipSignatories));
    $event.preventDefault();
    console.log('opening modal..', element.Id);
    const buttons = [
                  {
                    type: 'button',
                    label: 'Close',
                    clickFunction: 'close',
                    class: this.appConstants.buttonPrimary
                  }
                ];
    if ((element.CustomerEmailSent || element.CustomerSigned) && !element.allOwnersSigned){
      buttons.unshift(
        {
          type: 'button',
          label: element.CustomerSigned ? (element.OwnershipSignatories.length==1 ? 'Resend to owner' : 'Resend to owners') : 'Resend to proposed insured',
          clickFunction: 'resendToOwners',
          class: this.appConstants.buttonSecondary
        }
      )
    }

    let recipient=  '';
    if (element.CustomerSigned !== 1) {
      recipient = "proposed insured";
    } else if (element.CustomerSigned === 1) {
      if (element.signedSignators - 1 === 0) {
        recipient = "owner(s)";
      } else if(element.signedSignators - 1 > 0 && element.signedSignators < element.totalSignators) {
        recipient = "unsigned owner(s)";
      }
    }

    const modalRef = this.disclosure.open(ModalComponent, {
      disableClose: false,
      closeOnNavigation: true,
      data: {
        AppId: element.Id,
        ProposedInsuredEmailAddress: element.EmailAddress,
        ProposedInsuredName: element.FirstName + ' ' + element.LastName,
        ProposedInsuredSigned: element.CustomerSigned,
        OwnersInformation: element.OwnershipSignatories,
        EmailLogs: element.insuredEmails,
        size: '',
        // Array of screens
        screens: [
          {
            show: true,
            exit_btn: true,
            content: [
              {
                type: 'title',
                content: 'Customer E-sign:',
                class: this.appConstants.modalTitleBold
              },
              {
                type: 'signators_table',
                content: element, //app
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'button_group',
                buttons: buttons
              }
            ]
          },

          //success screen
          {
            show: false,
            exit_btn: true,
            content: [
              {
                type: 'title',
                content: 'Success!',
                class: this.appConstants.modalTitleBold
              },
              {
                type: 'text',
                content: "The application has been resent to the "+ recipient+'.',
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'button_group',
                buttons: [
                  {
                    type: 'button',
                    label: 'Return to portal',
                    clickFunction: 'close',
                    class: this.appConstants.buttonPrimary
                  }
                ]
              }
            ]
          },
          {          //failure screen

            show: false,
            exit_btn: false,
            error_flag: true,
            content: [
              {
                type: 'title',
                content: this.appConstants.somethingWentWrong,
                class: this.appConstants.modalTitleBold
              },
              {
                type: 'text',
                content: this.appConstants.technicalError,
                class: this.appConstants.modalParagraphDefault
              },
              {
                type: 'button_group',
                buttons: [
                  {
                    type: 'button',
                    label: 'Try Again',
                    clickFunction: 'resendToOwners',
                    class: this.appConstants.buttonSecondary
                  }
                ]
              }
            ]
          },
                    // Fail on retry screen
                    {
                      show: false,
                      exit_btn: false,
                      content: [
                        {
                          type: 'title',
                          content: this.appConstants.technicalIssueTitle,
                          class: this.appConstants.modalTitleBold
                        },
                        {
                          type: 'text',
                          content: ' We’re sorry, but we seem to be experiencing some technical issues at this time and cannot ' +
                          'resend the application to the ' + recipient +
                            ' for their signature(s). We ask that you please try again later, '+
                            ' and we apologize for any inconvenience this has caused.',
                          class: this.appConstants.modalParagraphDefault
                        },
                        {
                          type: 'button_group',
                          buttons: [
                            {
                              type: 'button',
                              label: 'Close',
                              clickFunction: 'close',
                              class: this.appConstants.buttonPrimary
                            }
                          ]
                        }
                      ]
                    },
                    {
                      show: false,
                      exit_btn: false,
                      content: [
                        {
                          type: 'title',
                          content: 'We received your resend request',
                          class: this.appConstants.modalTitleBold
                        },
                        {
                          type: 'text',
                          content: "In the next 2-3 minutes, all owners should receive an email that includes a link to their sections of the application. Once all owners have electronically signed the application, you will receive an email notification with next steps.",
                          class: this.appConstants.modalParagraphDefault
                        },
                        {
                          type: 'text',
                          content: "You can also track the status of the owner signature in the JH eApp portal.",
                          class: this.appConstants.modalParagraphDefault
                        },
                        {
                          type: 'button_group',
                          buttons: [
                            {
                              type: 'button',
                              label: this.appConstants.eAppPortalLabel,
                              clickFunction: 'goToAgentPortal',
                              class: this.appConstants.buttonPrimary
                            }
                          ]
                        }
                      ]
                    }
        ]
      }
    });

    modalRef.componentInstance.resendToOwnersEvent.subscribe(result => {
      console.log('resendToOwners', result);
    });
  }
}
